import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {DateRangePicker} from '@homeaway/react-date-pickers';
import {SVGIcon} from '@homeaway/react-svg';
import {CALENDAR__16} from '@homeaway/svg-defs/lib/defs/CALENDAR__16';
import {withTranslationsAsProps} from '../../../components/translations';

class DateRangePickerContainer extends Component {
    static propTypes = {
        locale: PropTypes.string,
        datesText: PropTypes.string,
        clearDatesText: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        onDatesClick: PropTypes.func,
        onNewDates: PropTypes.func
    }

    static defaultProps = {
        onDatesClick: () => {},
        onNewDates: () => {}
    }

    constructor(props) {
        super(props);

        const {startDate, endDate} = props;

        this.state = {
            startDate,
            endDate
        };
    }

    handleDateRangeChange = (startDate, endDate) => {
        this.setState({
            startDate,
            endDate
        });
    }

    handleDateRangeClose = () => {
        if (this.isDateChange()) {
            this.props.onNewDates(this.state.startDate, this.state.endDate);
        }
    }

    isDateChange = () => {
        return this.state.startDate !== this.props.startDate || this.state.endDate !== this.props.endDate;
    }


    render() {
        const dateFormatOptions = {month: 'short', day: 'numeric'};
        return (
            <form>
                <DateRangePicker
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    onDateRangeChange={this.handleDateRangeChange}
                    onOpen={this.props.onDatesClick}
                    onClose={this.handleDateRangeClose}
                    id="trip-board-date-range-picker"
                    inputLabel1={this.props.datesText}
                    inputName1="dates"
                    clearButtonLabel={this.props.clearDatesText}
                    consolidateInputs
                    dateFormatOptions={dateFormatOptions}
                    locale={this.props.locale}
                    inputIcon1={<SVGIcon markup={CALENDAR__16}/>}
                    showContinueButton
                />
            </form>
        );
    }
}

export default withTranslationsAsProps({
    'tripboards.date_picker.clear_dates': 'clearDatesText',
    'tripboards.date_picker.dates': 'datesText'
})(DateRangePickerContainer);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/date-range-picker.js